export default __webpack_public_path__ + "static/media/miguel-lopes-41.8593e34f.jpg";